module.exports = __webpack_public_path__ + "static/media/Refresh.4a73c50f.svg";